// Chat UI preferences (open, pin, sizes, placement) and the selected thread
// persist in localStorage (agentChatPreferences). The URL carries no chat
// state, so internal links need no chat-parameter propagation.

/** Chat parameters that must never survive onto internal links. */
export const CHAT_URL_PARAMS = ['thread', 'chat', 'chatPinned'] as const;

export const stripChatQuery = <T extends string | undefined>(
  href: T,
  currentURL: string,
): T => {
  if (!href || href.startsWith('#')) {
    return href;
  }
  try {
    const current = new URL(currentURL);
    const target = new URL(href, current);
    if (
      target.origin !== current.origin ||
      !['http:', 'https:'].includes(target.protocol)
    ) {
      return href;
    }
    let changed = false;
    for (const key of CHAT_URL_PARAMS) {
      if (target.searchParams.has(key)) {
        target.searchParams.delete(key);
        changed = true;
      }
    }
    if (!changed) {
      return href;
    }
    return `${target.pathname}${target.search}${target.hash}` as T;
  } catch {
    return href;
  }
};
